import * as types from "./types";

export const getRolesRequest = (payload) => ({
  type: types.GET_ROLES_LIST_REQUEST,
  payload,
});

export const getRolesResponse = (payload) => ({
  type: types.GET_ROLES_LIST_RESPONSE,
  payload,
});

export const getRoleRequest = (payload) => ({
  type: types.GET_ROLE_REQUEST,
  payload,
});

export const getRoleResponse = (payload) => ({
  type: types.GET_ROLE_RESPONSE,
  payload,
});

export const updateRoleStatusRequest = (payload) => ({
  type: types.UPDATE_ROLE_STATUS_REQUEST,
  payload,
});

export const updateRoleStatusResponse = (payload) => ({
  type: types.UPDATE_ROLE_STATUS_RESPONSE,
  payload,
});

export const editRoleRequest = (payload) => ({
  type: types.EDIT_ROLE_REQUEST,
  payload,
});

export const updateRoleRequest = (payload) => ({
  type: types.UPDATE_ROLE_REQUEST,
  payload,
});

export const deleteRoleRequest = (payload) => ({
  type: types.DELETE_ROLE_REQUEST,
  payload,
});

export const createRoleRequest = (payload) => ({
  type: types.CREATE_ROLE_REQUEST,
  payload,
});

export const createRoleResponse = (payload) => ({
  type: types.CREATE_ROLE_RESPONSE,
  payload,
});

export const promoteRoleRequest = (payload) => ({
  type: types.PROMOTE_ROLE_REQUEST,
  payload,
});

export const promoteRoleResponse = (payload) => ({
  type: types.PROMOTE_ROLE_RESPONSE,
  payload,
});

export const demoteRoleRequest = (payload) => ({
  type: types.DEMOTE_ROLE_REQUEST,
  payload,
});

export const demoteRoleResponse = (payload) => ({
  type: types.DEMOTE_ROLE_RESPONSE,
  payload,
});

export const getSingleRoleRequest = (payload) => ({
  type: types.GET_SINGLE_ROLE_REQUEST,
  payload,
});

export const getSingleRoleResponse = (payload) => ({
  type: types.GET_SINGLE_ROLE_RESPONSE,
  payload,
});

export const updateSingleRoleRequest = (payload) => ({
  type: types.UPDATE_SINGLE_ROLE_REQUEST,
  payload,
});

export const updateSingleRoleResponse = (payload) => ({
  type: types.UPDATE_SINGLE_ROLE_RESPONSE,
  payload,
});
